import template from './gazdalkodasikalkulator.pug';
import 'angular-scroll';
import gazdalkodasiKalkulatorServiceModule from './gazdalkodasikalkulator-service';
import talajtipusTerkep from './talajtipus-terkep/talajtipus-terkep';
import eredmenyNezet from './eredmeny/eredmeny';
import tabs from './tabs/tabs';
import osszesito from './osszesito/osszesito';
import popupTemplate from './megerosito-popup.pug';

const MODULE_NAME = 'gazdalkodasiKalkulator';
class GazdalkodasiKalkulatorController {
	constructor(gazdalkodasiKalkulatorService, $scope, $document, $timeout, environment, $uibModal) {
		'ngInject';
		this._gazdalkodasiKalkulatorService = gazdalkodasiKalkulatorService;
		this._$scope = $scope;
		this._$document = $document;
		this._$timeout = $timeout;
		this.pdfBaseUrl = `${environment.backendUrl}/do/gazdalkodasi/pdf/`;
		this.osszesitoPdfBaseUrl = `${environment.backendUrl}/do/gazdalkodasi/pdf/summary/`;
		this.showTalajSelectAfterMap = false;
		this.talajNameForMap = '';
		this.$uibModal = $uibModal;
		this.eredmenyModel = {
			eredmenyTabok: [],
			eredmenyIndex: null,
			kivalasztottEredmeny: null,
			osszesEredmeny: [],
			meglevoSzerkesztese: false,
			showOsszesito: false,
			formIsDirty: false
		};
		this.modelIsCreatedFromSession = false;
	}
	$onInit() {
		this.model = {
			gepiMunkakKoltsegei: []
		};
		this._gazdalkodasiKalkulatorService.init().then((response) => {
			this.novenyek = response[0];
			this.talajok = response[1];
			this.termesztesiSzinvonalak = response[2];
		}, () => {
			this.technikaiHiba = true;
		});
		// ha ujra bepiszkolodik a form a kalkulalas eredmeny torlese
		this._$scope.$watch('$ctrl.gazdalkodasiKalkulatorForm.$dirty', (newVal) => {
			if (newVal) {
				this.eredmenyModel.formIsDirty = true;
				if (this.eredmenyModel.osszesEredmeny.length > 0 && this.eredmenyModel.meglevoSzerkesztese) {
					this.eredmenyModel.kivalasztottEredmeny = null;
				}
			}
		});
		this._$scope.$watch(() => {
			return this.getAltalanosKoltseg();
		}, (newVal) => {
			if (newVal) {
				this.model.altalanosKoltsegek = this.getAltalanosKoltseg();
			}
		});
		this.buildModelFromSession();
	}
	_getSelectedText(array, value) {
		let valueArray = array.filter((item) => item.$href('self') == value);
		return valueArray[0].nev;
	}
	getAltalanosKoltseg() {
		return ((this._getKozvetlenKoltseg() * 10) / 100).toFixed(0);
	}
	_getGepiMunkaKoltseg() {
		let gepiMunkakKoltsegei = 0;
		if (this.model.gepiMunkakKoltsegei) {
			for (let munkaKoltseg of this.model.gepiMunkakKoltsegei) {
				let koltsegAlkalmankent = parseInt(munkaKoltseg.koltsegAlkalmankent, 10);
				let alkalom = parseInt(munkaKoltseg.alkalom, 10);
				gepiMunkakKoltsegei += (koltsegAlkalmankent || 0) * (alkalom || 0);
			}
		}
		return gepiMunkakKoltsegei;
	}
	_getKozvetlenKoltseg() {
		let szemelyjelleguKoltsegek = parseInt(this.model.szemelyjelleguKoltsegek, 10);
		let foldberletiDij = parseInt(this.model.foldberletiDij, 10);
		return this._getAnyagKoltseg() + this._getGepiMunkaKoltseg() + (szemelyjelleguKoltsegek || 0) + (foldberletiDij || 0);
	}
	_getAnyagKoltseg() {
		let mutragya = parseInt(this.model.mutragya, 10);
		let vetomag = parseInt(this.model.vetomag, 10);
		let novenyvedoszer = parseInt(this.model.novenyvedoszer, 10);

		return (mutragya || 0) + (vetomag || 0) + (novenyvedoszer || 0);
	}
	novenyKivalasztva(item) {
		this.gepiMunkak = item.novenyGepiMunkak;
		this.model.gepiMunkakKoltsegei = [];
		for (let gepiMunka of this.gepiMunkak) {
			let gepiMunkaHref = gepiMunka._links.gepiMunka.href.replace(/{(.*?)}/g, '');
			this.model.gepiMunkakKoltsegei.push({ gepiMunka: gepiMunkaHref, alkalom: 1 });
		}

	}
	ujKalkulacio() {
		this.modalPopup = this.$uibModal.open({
			animation: false,
			backdrop: false,
			scope: this._$scope,
			template: popupTemplate()
		});
	}

	resetAllModel() {
		this.modalPopup.close();
		this.resetOnlyFormForNewCalculation();
		this.eredmenyModel = {
			eredmenyTabok: [],
			eredmenyIndex: null,
			kivalasztottEredmeny: null,
			osszesEredmeny: [],
			showOsszesito: false
		};
		this.eredmenyModel.meglevoSzerkesztese = false;

		this._$timeout(() => {
			this._$document.scrollTopAnimated(0);
		}, 100);
	}

	kalkulal() {
		this._gazdalkodasiKalkulatorService.kalkulal(this.model).then((response) => {
			this.eredmenyModel.formIsDirty = false;
			this.errors = null;
			this.gazdalkodasiKalkulatorForm.$setPristine();
			let eredmeny = response.eredmeny;
			let eredmenyId = response.id;
			let noveny = this._getSelectedText(this.novenyek, this.model.noveny);
			let talaj = this._getSelectedText(this.talajok, this.model.talaj);
			let termesztesiSzinvonalText = this._getSelectedText(this.termesztesiSzinvonalak, this.model.termesztesiSzinvonal);
			this.setEredmenyModel(eredmeny, noveny, talaj, termesztesiSzinvonalText, eredmenyId);

			let formBottom = angular.element(document.getElementById('gazdalkodasi-kalkulator-eredmeny'));
			if (formBottom.length) {
				this._$timeout(() => {
					this._$document.scrollToElementAnimated(formBottom);
				}, 100);
			}

		}, (err) => {
			if (err.status && err.status == 400 && err.data && err.data.errors) {
				this.errors = err.data.errors;
			} else {
				this.technikaiHiba = true;
			}
		});
	}

	setEredmenyModel(eredmeny, noveny, talaj, termesztesiSzinvonalText, eredmenyId) {
		let isNewTab;
		let eredmenyTabNev = `${noveny} - ${talaj}`;
		eredmeny.noveny = noveny;
		eredmeny.talaj = talaj;
		eredmeny.termesztesiSzinvonalText = termesztesiSzinvonalText;
		eredmeny.teruletNagysaga = this.model.teruletNagysaga;
		eredmeny.pdfUrl = this.pdfBaseUrl + eredmenyId;
		eredmeny.eredmenyId = eredmenyId;

		if (!this.eredmenyModel.meglevoSzerkesztese) {
			isNewTab = true;
			this.eredmenyModel.osszesEredmeny.push({eredmeny: eredmeny, formModel: angular.copy(this.model)});
			this.eredmenyModel.eredmenyIndex = this.eredmenyModel.osszesEredmeny.length - 1;

			this.setEredmenyTabs(isNewTab, eredmenyTabNev, this.eredmenyModel.eredmenyIndex);
			this.selectEredmenyToShow(this.eredmenyModel.eredmenyIndex);
		} else {
			isNewTab = false;
			this.eredmenyModel.osszesEredmeny[this.eredmenyModel.eredmenyIndex].eredmeny = eredmeny;
			this.eredmenyModel.osszesEredmeny[this.eredmenyModel.eredmenyIndex].formModel = angular.copy(this.model);
			this.eredmenyModel.kivalasztottEredmeny = this.eredmenyModel.osszesEredmeny[this.eredmenyModel.eredmenyIndex].eredmeny;
			this.setEredmenyTabs(isNewTab, eredmenyTabNev, this.eredmenyModel.eredmenyIndex);
		}

		this.eredmenyModel.meglevoSzerkesztese = true;
		this._gazdalkodasiKalkulatorService.putModelData(this.eredmenyModel, this.gepiMunkak);
	}

	setEredmenyTabs(isNewTab, eredmenyTabNev, eredmenyIndex) {
		if (isNewTab) {
			this.eredmenyModel.eredmenyTabok.push({nev: eredmenyTabNev, tabId: eredmenyIndex});
		} else {
			this.eredmenyModel.eredmenyTabok[this.eredmenyModel.eredmenyIndex] = {nev: eredmenyTabNev, tabId: this.eredmenyModel.eredmenyIndex};
		}
		this.eredmenyModel.eredmenyTabok = angular.copy(this.eredmenyModel.eredmenyTabok); // use for trigger $onChange
	}

	setTalajTipus(nev) {
		for (let talaj of this.talajok) {
			if (talaj.nev == nev) {
				this.model.talaj = talaj.$href('self');
				this.talajNameForMap = nev;
				break;
			}
		}
		if (this.model.talaj) {
			this.showTalajSelectAfterMap = true;
		}
	}

	setTalajNameForMap(link) {
		for (let talaj of this.talajok) {
			if (talaj.$href('self') == link) {
				this.talajNameForMap = talaj.nev;
				return;
			}
		}
	}

	masraisKalkulalok() {
		this.eredmenyModel.meglevoSzerkesztese = false;
		this.resetOnlyFormForNewCalculation();
		this._$timeout(() => {
			this._$document.scrollTopAnimated(0);
		}, 100);
	}

	selectEredmenyToShow(eredmenyIndex) {
		if (eredmenyIndex > this.eredmenyModel.osszesEredmeny.length - 1) { // az osszesito van kivalasztva
			this.eredmenyModel.kivalasztottEredmeny = null;
			this.eredmenyModel.showOsszesito = true;
			this.eredmenyModel.meglevoSzerkesztese = false;
			this.resetOnlyFormForNewCalculation();
			this.createOsszesitoPdfUrl();
		} else {
			this.eredmenyModel.meglevoSzerkesztese = true;
			this.showTalajSelectAfterMap = true;
			this.eredmenyModel.showOsszesito = false;
			this.eredmenyModel.kivalasztottEredmeny = this.eredmenyModel.osszesEredmeny[eredmenyIndex].eredmeny;
			this.model = angular.copy(this.eredmenyModel.osszesEredmeny[eredmenyIndex].formModel);
			this.pdfUrl = this.eredmenyModel.osszesEredmeny[eredmenyIndex].eredmeny.pdfUrl;
		}
	}

	createOsszesitoPdfUrl() {
		let ids = '';
		for (let eredmeny of this.eredmenyModel.osszesEredmeny) {
			ids += eredmeny.eredmeny.eredmenyId + ',';
		}
		this.pdfUrl = this.osszesitoPdfBaseUrl + ids;
		this.pdfUrl = this.pdfUrl.substring(0, this.pdfUrl.length - 1);
	}

	onSelectTab(tabId) {
		this.gazdalkodasiKalkulatorForm.$setPristine();
		this.eredmenyModel.formIsDirty = false;
		this.eredmenyModel.eredmenyIndex = tabId;
		this.selectEredmenyToShow(tabId);
	}

	resetOnlyFormForNewCalculation() {
		this.model = {
			gepiMunkakKoltsegei: []
		};
		this.showTalajSelectAfterMap = false;
		this.talajNameForMap = '';
	}

	buildModelFromSession() {
		let modelData = this._gazdalkodasiKalkulatorService.getModelData();
		if (modelData) {
			this.modelIsCreatedFromSession = true;
			this.eredmenyModel = modelData.eredmenyModel;
			this.gepiMunkak = modelData.gepiMunkak;
			this.selectEredmenyToShow(this.eredmenyModel.eredmenyIndex);
		}
	}
}

export default angular.module(MODULE_NAME, [gazdalkodasiKalkulatorServiceModule, talajtipusTerkep, eredmenyNezet, tabs, osszesito, 'duScroll'])
	.component('gazdalkodasiKalkulator', {
		controller: GazdalkodasiKalkulatorController,
		template: template()
	}).name;



// WEBPACK FOOTER //
// ./source/applications/kalkulator/gazdalkodasikalkulator/gazdalkodasikalkulator.js